import { useMemo } from "react";
import { t } from "@/i18n";

export function HeroTip({ tips, onAction }: { tips: [string, string][]; onAction: (kind: string, text: string) => void }) {
  const [text, kind] = useMemo(() => tips[Math.floor(Math.random() * tips.length)], [tips]);
  return (
    <div className="flex-1 flex flex-col items-center justify-center text-center py-12" data-testid="ask-empty">
      <button onClick={() => onAction(kind, text)} className="relative mb-3 bubble-in !rounded-2xl text-sm font-medium hover:opacity-80 transition-opacity rise" data-testid="hero-tip">
        {t(text)}
        <span className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-3 h-3 rotate-45 bg-[var(--bubble-in)]" />
      </button>
      <img src="/mascot.png" alt="" className="h-28 w-auto rise d1" />
      <p className="text-xl font-semibold mt-3">{t("How can I help?")}</p>
    </div>
  );
}
